
import { defineComponent } from 'vue'
import ProductsList from '@/components/ProductsList.vue'
import CartWidget from '@/components/CartWidget.vue'

export default defineComponent({
  name: 'Home',
  components: {
    ProductsList,
    CartWidget,
  },
})
